import { useEffect } from 'react'

import { getDisallowedStrategiesFromSelectedState } from '../../../tradebuilder-v2/modules/00-builder/state/mappers'
import { FundingSource } from '../../../tradebuilder-v2/modules/02-terms/state/terms-slice'
import { actions as rawActions } from '../../../tradebuilder-v2/modules/04-strategy/state/strategy-slice'
import { StrategyStepStateless } from '../../../tradebuilder-v2/modules/04-strategy/templates'
import { useAppSelector } from '../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../tradebuilder-v2/store/use-actions'

export function TradeEditStrategyStep() {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.strategy)
  const portfolio = useAppSelector(state => state.portfolio)
  const terms = useAppSelector(state => state.terms)
  const actions = useActions(rawActions)

  useEffect(() => {
    const params = {
      client: builderState.client,
      accountId: builderState.accountId
    }
    if (params.client && params.accountId && !state.isInited) {
      actions.init(params)
    }
    const currentAccountState = builderState.savedState?.account?.currentAccountState
    if (currentAccountState && portfolio) {
      // For a new trade for the first time or creating a new edit for the first time
      actions.setStrategiesExisting({
        disallowedStrategies: getDisallowedStrategiesFromSelectedState(
          portfolio,
          builderState.businessUnit
        ),
        isTransfer: terms.terms.fundingSource === FundingSource.Transfer
      })
    }
  }, [
    state.isInited,
    builderState.client,
    builderState.accountId,
    portfolio,
    builderState.savedState?.account?.currentAccountState,
    builderState.businessUnit,
    actions,
    terms.terms.fundingSource
  ])

  const onSaveAndContinue = () => {
    actions.updateAndMoveNext()
  }
  const onMoveBack = () => {
    actions.moveBack()
  }
  const onCloseAssetInspection = () => {
    actions.stopInspectingAsset()
  }
  return (
    <StrategyStepStateless
      actions={actions}
      state={state}
      onCloseInspection={onCloseAssetInspection}
      onMoveBack={onMoveBack}
      onSaveAndContinue={onSaveAndContinue}
    />
  )
}
